import { motion, useReducedMotion } from "framer-motion";
import styles from "./Burst.module.css";

const COLORS = ["#22D3EE", "#A78BFA", "#FACC15", "#FB7185"];
const COUNT = 14;

export default function Burst({ fullscreen = false }: { fullscreen?: boolean }) {
  const reduce = useReducedMotion();
  if (reduce) return null;
  const distance = fullscreen ? 320 : 160;
  return (
    <div className={fullscreen ? styles.fullscreen : styles.local} aria-hidden="true">
      {Array.from({ length: COUNT }, (_, i) => {
        const a = (i / COUNT) * Math.PI * 2;
        return (
          <motion.span
            key={i}
            className={styles.particle}
            style={{ background: COLORS[i % COLORS.length] }}
            initial={{ x: 0, y: 0, scale: 1, opacity: 1 }}
            animate={{
              x: Math.cos(a) * distance,
              y: Math.sin(a) * distance,
              scale: 0.3,
              opacity: 0,
              rotate: 180,
            }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          />
        );
      })}
    </div>
  );
}
